module.exports = __webpack_public_path__ + "static/img/img-crtfPassNew.64a5ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-crtfPassNew.png
// module id = 4FuT
// module chunks = 1